export default [
  {
    path: "trafficCosts",
    name: "trafficCosts",
    component: (): Promise<any> => import(/* webpackChunkName: "webmaster:subAccounts" */ "@/views/Webmaster/TrafficCosts.vue")
  }
];